import type { AssignmentListItem } from 'api/assignments/types';

export function requiresSupplierSignature(
    bookingConfirmation: AssignmentListItem['bookingConfirmation'] | undefined
): boolean {
    return (
        bookingConfirmation?.requiresSignature === true &&
        bookingConfirmation?.document?.signedBySupplier === false
    );
}
